import React, { useState } from "react";
import axios from "axios";
import { Send } from "lucide-react";
import { IMAGES } from "../mock";
import { useToast } from "../hooks/use-toast";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Subscribe() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/newsletter`, { email });
      toast({
        title: "Danke für Ihr Interesse!",
        description: res.data?.message || `Wir haben ${email} hinzugefügt.`,
      });
      setEmail("");
    } catch (err) {
      toast({
        title: "Anmeldung fehlgeschlagen",
        description: "Bitte prüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      className="bg-fixed-overlay text-center py-24"
      style={{ backgroundImage: `url(${IMAGES.subscribeBg})` }}
    >
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="max-w-[620px] mx-auto text-white">
          <h3 className="text-3xl font-bold text-white mb-4">Bleiben Sie auf dem Laufenden</h3>
          <p className="text-white/80 leading-relaxed mb-8">
            Erhalten Sie Neuigkeiten zu neuen SaaS-Features, KI-Integrationen und
            Best Practices aus der Schweizer Softwareentwicklung – direkt in Ihr Postfach.
          </p>
          <form onSubmit={submit} className="flex bg-white rounded-full p-1.5 max-w-[520px] mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Ihre E-Mail-Adresse"
              className="flex-1 bg-transparent px-5 text-slate-700 outline-none"
              required
            />
            <button type="submit" className="btn-theme sm" aria-label="Abonnieren" disabled={loading}>
              <Send size={17} />
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
